export default "__VITE_ASSET__BvAdZSHA__"